// import classes from "./confirmModal.module.css";

// export const ConfirmModal = ({
//   title,
//   message,
//   onConfirm,
//   onCancel,
// }) => {
//   return (
//     <div
//       className={classes.modalOverlay}
//       onClick={onCancel}
//     >
//       <div
//         className={classes.modalBox}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className={classes.modalHeader}>
//           <h3 className={classes.modalTitle}>
//             {title}
//           </h3>
//         </div>

//         <p className={classes.modalMessage}>
//           {message}
//         </p>

//         <div className={classes.modalActions}>
//           <button
//             className={classes.cancelBtn}
//             onClick={onCancel}
//           >
//             Cancel
//           </button>

//           <button
//             className={classes.confirmBtn}
//             onClick={onConfirm}
//           >
//             Yes, Change Status
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };


// import { useState } from "react";
import classes from "./confirmModal.module.css";
// import { toast } from "react-toastify";
// import {
//   useGetInvoiceQuery,
//   useUploadInvoiceMutation,
// } from "../../services/orderDetailApiSlice";

export const ConfirmModal = ({
  title,
  message,
  onConfirm,
  onCancel,
  nextStatus,
  currentStatus, // ✅ IMPORTANT
  shipment_id,
  orderId,
}) => {
  // const [file, setFile] = useState(null);
  // const [isUploaded, setIsUploaded] = useState(false); // 🔥 instant UI

  // // 🔥 normalize
  // const next = nextStatus?.toLowerCase()?.trim();
  // const current = currentStatus?.toLowerCase()?.trim();

  // // 🔥 upload required condition
  // const requireUpload = next === "packed" || current === "in process";

  // // ✅ GET INVOICE (only when needed)
  // const { data, refetch } = useGetInvoiceQuery(
  //   { orderId, shipment_id },
  //   { skip: !requireUpload },
  // );

  // const invoiceUrl = data?.invoice_url || data?.data?.invoice_url;

  // // ✅ UPLOAD
  // const [uploadInvoice, { isLoading }] = useUploadInvoiceMutation();

  // const handleFileChange = async (e) => {
  //   const selectedFile = e.target.files?.[0];
  //   if (!selectedFile) return;

  //   setFile(selectedFile);

  //   try {
  //     await uploadInvoice({
  //       orderId,
  //       shipment_id,
  //       file: selectedFile,
  //     }).unwrap();

  //     toast.success("Invoice uploaded");

  //     // 🔥 INSTANT ENABLE BUTTON
  //     setIsUploaded(true);

  //     // optional (sync backend)
  //     refetch();
  //   } catch (err) {
  //     toast.error(err?.data?.message?.displayMessage || "Upload failed");
  //   }
  // };

  // // 🔥 FINAL BUTTON CONDITION
  // const isDisabled = requireUpload && !(invoiceUrl || isUploaded);

  return (
    <div className={classes.modalOverlay} onClick={onCancel}>
      <div className={classes.modalBox} onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className={classes.modalHeader}>
          <h3 className={classes.modalTitle}>{title}</h3>
        </div>

        {/* MESSAGE */}
        <p className={classes.modalMessage}>{message}</p>

        {/* UPLOAD SECTION */}
        {/* {requireUpload && (
          <div className={classes.uploadSection}>
            <p className={classes.uploadText}>
              {!invoiceUrl && !isUploaded
                ? "Please upload PDF to continue"
                : "Invoice uploaded successfully"}
            </p>

            {!invoiceUrl && !isUploaded && (
              <label className={classes.uploadBtn}>
                {isLoading ? "Uploading..." : "Upload Invoice PDF"}
                <input
                  type="file"
                  accept="application/pdf"
                  hidden
                  onChange={handleFileChange}
                />
              </label>
            )}

            {file && !invoiceUrl && !isUploaded && (
              <p className={classes.fileName}>{file.name}</p>
            )}

            {(invoiceUrl || isUploaded) && (
              <a
                href={invoiceUrl}
                target="_blank"
                rel="noreferrer"
                className={classes.fileName}
              >
                View Uploaded Invoice
              </a>
            )}
          </div>
        )} */}

        {/* ACTIONS */}
        <div className={classes.modalActions}>
          <button className={classes.cancelBtn} onClick={onCancel}>
            Cancel
          </button>

          <button
            className={classes.confirmBtn}
            onClick={onConfirm}
            // disabled={isDisabled}
          >
            Yes, Change Status
          </button>
        </div>
      </div>
    </div>
  );
};
